<template>
  <div>
    <b-row align-h="around" class="mt-5">
      <b-col class="simulacro-button" v-for="(items, key) in simulacros" :key="key" lg="6">
        <div  style="display: inline-grid;" v-if="items.is_universidad==1">
          <img
          @click="goRouter(items.id_simulacro)"
          src="@/assets/images/university1.png"
          alt
          />
        </div>

        <div  style="display: flex; justify-content: center;align-items: center;flex-direction: column;" v-if="items.is_universidad==0">
          <img
          @click="goRouter(items.id_simulacro)"
          src="@/assets/images/university-g.png"
          alt
          />
          <br>
          {{items.nombre}}
        </div>
        

      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "select-simulacros",
  props: {
    url: {
      type: String
    },
    select: {
      type: Number
    }
  },
  data: () => ({
    simulacros: ""
  }),
  created() {
    let data= {
        key: localStorage.getItem('idkey'),
        id: localStorage.getItem('id_carrera'),
    }
    if (this.select==1) {
      this.$store.dispatch("getSimulacrosXcarrera", data).then(response => {
        this.simulacros = response.data.simulacro;
      });
    } else {
      this.$store.dispatch("getSimulacros").then(response => {
        this.simulacros = response.data.simulacro;
      });
    }
  },

  mounted() {},
  methods: {
    goRouter(id) {
      this.$store.dispatch("setSimulacros", id);
      this.$router.push({ name: this.url });
    }
  }
};
</script>
<style scoped>
</style>
